import { Box, BoxProps, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import WhiteBoxContent from 'src/components/common/WhiteBoxContent';

export const ButtonFilterSchedule = ({
  children,
  isActive,
  boxProps,
}: {
  children: ReactNode;
  isActive: boolean;
  boxProps?: BoxProps;
}) => {
  const {
    shape: { borderRadius },
    palette: { divider, primary },
  } = useTheme();
  const border = !isActive ? '1px solid' + divider : '1px solid' + primary.main;
  return (
    <Box
      component={'span'}
      sx={{ cursor: 'pointer' }}
      borderRadius={borderRadius / 2}
      border={border}
      fontSize={12}
      px={2}
      py={0.5}
      {...boxProps}
    >
      {children}
    </Box>
  );
};

export const ListButtonFilterSchedule = [
  {
    label: 'Finishes',
    value: 'finishes',
  },
  {
    label: 'In Progress',
    value: 'in_progress',
  },
  {
    label: 'Late',
    value: 'late',
  },
];

export const VesselDetailBox = ({ children, ...others }: BoxProps) => {
  return (
    <WhiteBoxContent boxShadow={'0px 0px 50px 0px rgba(112, 114, 176, 0.08)'} {...others}>
      {children}
    </WhiteBoxContent>
  );
};
